export class UserEntity {
  id: number

  firstName: string

  lastName: string

  name?: string

  organizationName: string

  email: string

  role: string

  action: string

  raw: any

  constructor(data: any) {
    this.raw = data || {}
    this.id = Number(data?.id || data?.user_id || 0)
    this.firstName = data?.firstName || data?.first_name || ''
    this.lastName = data?.lastName || data?.last_name || ''
    this.name = typeof data?.name === 'string' ? data.name : undefined
    this.organizationName =
      data?.organizationName ||
      data?.organization_name ||
      data?.companyName ||
      data?.company_name ||
      (typeof data?.organization === 'string'
        ? data.organization
        : data?.organization?.name) ||
      ''
    this.email = data?.email || ''
    this.role = data?.role || data?.role_name || ''
    this.action = data?.action || ''
  }

  /**
   * Casts raw data or object to UserEntity instance
   */
  static from(data: any): UserEntity {
    if (data instanceof UserEntity) return data
    return new UserEntity(data)
  }

  /**
   * Returns full formatted user name (LastName FirstName) or name property or fallback string
   */
  getFullName(fallback = 'ユーザー'): string {
    const full = `${this.lastName} ${this.firstName}`.trim()
    if (full) return full
    if (this.name) return this.name
    return fallback
  }

  /**
   * Returns organization name or fallback
   */
  getOrganizationName(fallback = '-'): string {
    return this.organizationName || fallback
  }
}

export default UserEntity
